import Vue from 'vue'
// import EventRootData from './EventRootData'
import EventUser from './EventUser'
import EventAct from './EventAct'
import EventBenefit from './EventBenefit'
import {ACT_NOT_INIT, ACT_RUNNING} from '../constant/act_stat'
import {isAndroid} from '../tools/mgtv/env'
import {get_appversion_from_ua} from '../tools/mgtv/version'


const EventBus = new Vue({
    data: {
      is_need_test_password: false, //预览页面中 如果没有输入过测试密码为真
      invalid_message: '', //页面异常提示,如果有设置，则点击时提示。 目前的场景有UA限制。
      act: {
        start_time: null,//开始时间
        end_time: null,//结束时间
        act_stat: ACT_NOT_INIT,
        ext: {}
      },
      tpl: null, //模板组件
      user: {
        uuid: null,
        vip_id: -1,
        nickname: "游客",
        avatar: "//vipcdn.mgtv.com/upload3/201903/avatar-login.png",
        user_type: -1, // 0会员用户(有首冲，且是会员)　1新用户（无首冲）　2会员老用户（有首冲非会员）
        level: 0,//会员等级
        mobile: ''
      },
      device_info: {
        appVersion: get_appversion_from_ua(),
        mac: '0000-0000-0000',
        did: '0000-0000-0000',
        osType: isAndroid() ? 'android' : 'ios',
        notInit : 1 //虚拟的，实际还没有初始化
      },
      channel_chooser: {
        show: false,
      },
      rootdata: window.rootdata,
      needRemoveLoading: false,
    },
    computed: {
      textMainColorStyle:function(){
        if(!window.$bus.tpl.tpl_page.customColorTextMain){
          return {}
        }
        return {
          color:window.$bus.tpl.tpl_page.customColorTextMain
        }
      },
      textSubColorStyle:function(){
        if(!window.$bus.tpl.tpl_page.customColorTextSub){
          return {}
        }
        return {
          color:window.$bus.tpl.tpl_page.customColorTextSub
        }
      }
    }
  })
;





EventBus.$useEvent = function (EventPlugin) {
  if (!EventPlugin) {
    throw new Error("事件插件不能为空");
  }
  if (!EventPlugin.install) {
    throw new Error("事件插件需要实现install方法");
  }
  EventPlugin.install(EventBus);
}

EventBus.$useEvent(EventUser);
EventBus.$useEvent(EventAct);
EventBus.$useEvent(EventBenefit);


window.$bus = EventBus;

